var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('CThemeProvider',[_c('CColorModeProvider',[_c('CBox',{attrs:{"font-family":"body","bg":"#0e0e0e","as":"main"}},[_c('CReset'),_vm._v(" "),_c('Nuxt')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }